import React from 'react';
import './OrderItemSummary.scss';
import { Divider } from 'antd';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';



interface IProps {
  item: Julius.Website.OrderItemViewModel;
 
}
const PurchaseItem: React.SFC<IProps> = ({
  item: {
    name,
    count,
    price,
    reducedPrice,
    totalPrice,
    reducedTotalPrice, 
    rowNbr,
    seatNbr, 
  },

}) => {
  
  const isReduced = price !== reducedPrice;
  const priceStyle = isReduced ? 'overline' : '';

  const elements = seatNbr
  const rowelements = rowNbr
  
 
  return (
    <>
      <div className='summary-item'>
        <div className='name-container'>
          <span className='sub-title medium-bold'>{ name }</span> á&nbsp;
          <PriceItem style={ `${ priceStyle }` } price={ price } decimals={ 2 } />&nbsp;
          { isReduced &&  
            <PriceItem price={ reducedPrice } decimals={ 2 } /> 
          }
           <div><PriceItem style={ `price-item medium-bold    ${ priceStyle }` } price={ totalPrice } decimals={ 2 } />
          { isReduced && 
            <PriceItem style='price-item medium-bold reduced' price={ reducedTotalPrice } decimals={ 2 } /> 
          }
        </div>
        </div> 
          
        <div className='seat-container'>
          <div>
            
          {(elements != null) && (elements.length == 0) && 
             <div>Onumrerad</div>
          }
          
          {(elements != null) && elements.map((value, index) => {
            const value2 = rowelements[index]
          return <div key={index}>Plats {value} Rad {value2}</div>
           })}

           
          </div>
        </div>

       <div className='quantity-container'>
          <span>{ count }</span>
        </div>
      
       </div> 
      <Divider />
    </>
  

  );

  
   
}

export default PurchaseItem;


// WEBPACK FOOTER //
// ./src/components/OrderItemSummary/PurchaseItem.tsx